import React from 'react';
import { getCurrentDate } from '../../helpers/Common';
import SearchBox from './common/SearchBox';
import { connect } from 'react-redux';
import PriceInfo from './PriceInfo';
import { I18n } from 'react-redux-i18n';
import ScoreBox from './Score';
import GroupButton from '../common/header/group-button';
import Noti from './Noti';
import { Export } from '../../common/export';
import Const from './Const';
import { REDUCER_NAME } from './reducer';
import { withComponentId } from '../../common/ComponentIdContext';
import { compose } from 'redux';

class FAHead extends React.Component {
  getExportName = () => {
    const { currentSearch } = this.props;
    return I18n.t('common.export.snapshot', {
      ticker: currentSearch.displayCode,
      date: getCurrentDate(),
    });
  };

  render() {
    const { dragCode, id, currentSearch } = this.props;
    const idFormExport = 'fa-snapshot-export' + id;

    return (
      <div className="fa-top-content top-nav flex-column h-100">
        <div className="d-flex mb-10">
          <div className="d-flex w-100">
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center" id="search">
                <div className="d-flex flex-column mr-20">
                  <SearchBox />
                  <PriceInfo dragCode={dragCode} />
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <ScoreBox dragCode={dragCode} />
              <GroupButton code={currentSearch.displayCode} />
              <Noti id={id} />
            </div>
            <div
              className="d-flex align-items-center"
              style={{ paddingBottom: 10, marginLeft: 'auto' }}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => ({
  i18n: state.i18n,
  currentSearch:
    state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
});

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(FAHead);

// <div className="align-self-end">
// <Export
//   exportId={idFormExport}
//   exportName={this.getExportName()}
//   exportConfigs={Const.exportConfigs(currentSearch.isBanking)}
//   title="common.PRINT"
// />
// </div>
